import { render, staticRenderFns } from "./TitleSidebar.vue?vue&type=template&id=0405b2c6&"
import script from "./TitleSidebar.vue?vue&type=script&lang=ts&"
export * from "./TitleSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TitleSidebar.vue?vue&type=style&index=0&id=0405b2c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports